import {Partner} from '../model/admin/partner';
import {BaseResponse} from './internal/baseresponse';
export class PartnerDetailResult extends BaseResponse {
  data: Partner;
}



// WEBPACK FOOTER //
// ./src/app/response/partnerdetailresult.ts